import { useLocale } from "../../../hooks/useLocale";
import { msg } from "../../../locales/translate";
import { useState } from "react";
import { Check, Copy } from "lucide-react";

export function PortfolioStatus({ status = "" }: { status?: string }) {
	useLocale();
	const [color, background] = status === "active" ? ["#16805d", "#effaf5"]
		: ["blocked", "withdrawal_blocked", "rejected"].includes(status) ? ["#b42332", "#fff1f2"]
			: ["submitted", "aml_review", "board_review", "in_progress"].includes(status) ? ["#946200", "#fff8e9"] : ["#667085", "#f2f4f7"];
	const label = status.replaceAll("_", " ");
	return <span className="severity" style={{ color, background }}>{label ? label.charAt(0).toUpperCase() + label.slice(1) : "—"}</span>;
}

export function PortfolioCopyId({ id, entity, showLabel = true }: { id: number; entity: "client" | "merchant"; showLabel?: boolean }) {
	useLocale();
	const [copyStatus, setCopyStatus] = useState("");
	return <>
		<button type="button" className="copy-id" title={copyStatus || msg("templateCopyId_9a9adedb", { v0: entity })} aria-label={msg("templateCopyId_d3ac79c4", { v0: entity, v1: id })} onClick={async event => {
			event.stopPropagation();
			try { await navigator.clipboard.writeText(String(id)); setCopyStatus("Copied"); } catch { setCopyStatus(msg("couldNotCopyId")); }
		}}>{showLabel && msg("id_efb046db")}{id}{copyStatus === "Copied" ? <Check size={11} /> : <Copy size={11} />}</button>
		{copyStatus && <span role="status">{copyStatus}</span>}
	</>;
}
